/**
 * Created by yuxin.zhang on 2017/12/3.
 */

import React from 'react';
import { autorun } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Input, Button } from '@ok/okd';

import AccountContext from '../../container/account/AccountContext';
import * as Check from '../../utils/Check';
import './index.less';

// 样式使用全局样式 formLine.less

const CODE_LENGTH = 6;

const CODE_FROM_ADDRESS = 'address';
const CODE_FROM_WITHDRAW = 'withdraw';
const CODE_FROM_USERS = 'users';
const CODE_FROM_ASSET = 'asset';
const CodeFrom = {
  address: CODE_FROM_ADDRESS,
  withdraw: CODE_FROM_WITHDRAW,
  users: CODE_FROM_USERS,
  asset: CODE_FROM_ASSET,
};

const CodeBox = inject('verifyStore')(
  inject('profileStore')(
    observer(
      class CodeBox extends AccountContext {
        constructor(props) {
          super(props);

          this.state = {
            googleCode: '',
            googleCodeError: '',

            smsCode: '',
            smsCodeError: '',
            voiceCodeError: '',

            emailCode: '',
            emailCodeError: '',

            emailApiError: '',
            smsApiError: '',
            voiceApiError: '',

            behavior: '',
            smsCodeTime: 0,
            voiceCodeTime: 0,
            emailCodeTime: 0,
            codeType: 1, // 默认短信
            focusItem: '',
            blurItem: '',

            sendToEmail: false,
            sendToSms: false,
            smsBtnDisabled: false,
            voiceBtnDisabled: false,
            emailBtnDisabled: false,
          };

          this.smsTimeClock = null;
          this.emailTimeClock = null;
          this.mounted = true;
        }

        componentDidMount() {
          this.mounted = true;
          this.cleanAutorun = autorun(() => {
            if (this.mounted) {
              this.cleanValue();
              this.cleanError();
            }
          });
        }

        componentWillUnmount() {
          this.mounted = false;
          this.cleanAutorun();
          if (this.smsTimeClock) {
            clearInterval(this.smsTimeClock);
          }
          if (this.emailTimeClock) {
            clearInterval(this.emailTimeClock);
          }
        }

        /**
         * 谷歌验证码变化监听
         * @param e
         */
        googleCodeChange = (e) => {
          const val = Check.filterNumber(e.target.value);
          let googleCodeError = '';

          if (val.length === 0) {
            googleCodeError = this.translate('codeBox.inputGoogleCode');
          } else if (val.length < CODE_LENGTH && val.length > 0) {
            googleCodeError = this.translate('codeBox.inputCodeLength', {
              num: CODE_LENGTH,
            });
          }

          this.setState(
            {
              googleCode: val,
              googleCodeError,
              blurItem: '',
            },
            () => {
              this.codeChange();
            }
          );
        };

        /**
         * 短信验证码变化监听
         * @param e
         */
        smsCodeChange = (e) => {
          const val = Check.filterNumber(e.target.value);
          let smsCodeError = '';

          if (val.length === 0) {
            smsCodeError = this.translate('codeBox.inputSmsCode');
          } else if (val.length < CODE_LENGTH && val.length > 0) {
            smsCodeError = this.translate('codeBox.inputCodeLength', {
              num: CODE_LENGTH,
            });
          }
          this.setState(
            {
              smsCode: val,
              smsCodeError,
              blurItem: '',
            },
            () => {
              this.codeChange();
            }
          );
        };

        /**
         * 语音验证码变化监听
         * @param e
         */
        voiceCodeChange = (e) => {
          const val = Check.filterNumber(e.target.value);
          let voiceCodeError = '';

          if (val.length === 0) {
            voiceCodeError = this.translate('codeBox.inputVoiceCode');
          } else if (val.length < CODE_LENGTH && val.length > 0) {
            voiceCodeError = this.translate('codeBox.inputCodeLength', {
              num: CODE_LENGTH,
            });
          }
          this.setState(
            {
              smsCode: val,
              voiceCodeError,
              blurItem: '',
            },
            () => {
              this.codeChange();
            }
          );
        };

        /**
         * 邮件验证码变化监听
         * @param e
         */
        emailCodeChange = (e) => {
          const val = Check.filterNumber(e.target.value);
          let emailCodeError = '';

          if (val.length === 0) {
            emailCodeError = this.translate('codeBox.inputEmailCode');
          } else if (val.length < CODE_LENGTH && val.length > 0) {
            emailCodeError = this.translate('codeBox.inputCodeLength', {
              num: CODE_LENGTH,
            });
          }
          this.setState(
            {
              emailCode: val,
              emailCodeError,
              blurItem: '',
            },
            () => {
              this.codeChange();
            }
          );
        };

        /**
         * code变化时 回调父级传入函数
         */
        codeChange = () => {
          const { verifyStore, verify } = this.props;
          const type = verify || verifyStore.verifyType;
          const { smsCode, googleCode, emailCode } = this.state;
          let allow = true;

          allow =
            allow && (type.google ? googleCode.length === CODE_LENGTH : true);
          allow =
            allow &&
            (type.sms || type.voice ? smsCode.length === CODE_LENGTH : true);
          allow =
            allow && (type.email ? emailCode.length === CODE_LENGTH : true);

          if (type.onlyNeedLoginPWD) {
            allow = true;
          }
          const verifyData = {
            allow,
            googleCode,
            smsCode,
            emailCode,
          };
          verifyStore.onChange(verifyData);
          // 回调父级传入的函数 参数分别为 是否通过格式检验,谷歌验证码,短信验证码,邮件验证码,错误信息
          if (this.props.onChange) {
            this.props.onChange(verifyData);
          }
        };

        /**
         * 发送短信验证码
         */
        sendSmsCode = () => {
          const {
            codeFrom,
            behavior,
            areaCode,
            phone,
            noAuth,
            token,
            verifyStore,
            currencyId,
          } = this.props;
          this.setState({
            smsApiError: '',
            smsBtnDisabled: true,
          });
          verifyStore.sendSmsCode(
            codeFrom || CodeFrom.security,
            codeFrom === CodeFrom.security || codeFrom === CodeFrom.asset
              ? {
                  behavior: behavior || '',
                  areaCode: areaCode || '',
                  phone: phone || '',
                  token: token || '',
                }
              : { currencyId },
            () => {
              this.smsSendTimeDown();
              this.setState({
                smsApiError: '',
                sendToSms: true,
                smsBtnDisabled: false,
              });
            },
            (res) => {
              this.setState({
                smsApiError: res.msg,
                smsBtnDisabled: false,
              });
            },
            noAuth
          );
        };

        /**
         * 发送语音验证码
         */
        sendVoiceCode = () => {
          const {
            codeFrom,
            behavior,
            areaCode,
            phone,
            noAuth,
            token,
            verifyStore,
            currencyId,
          } = this.props;
          this.setState({
            voiceApiError: '',
            voiceBtnDisabled: true,
          });
          verifyStore.sendVoiceCode(
            codeFrom || CodeFrom.security,
            codeFrom === CodeFrom.security
              ? {
                  behavior,
                  areaCode: areaCode || '',
                  phone: phone || '',
                  token: token || '',
                }
              : { currencyId },
            () => {
              this.voiceSendTimeDown();
              this.setState({
                voiceApiError: '',
                sendToSms: true,
                voiceBtnDisabled: false,
              });
            },
            (res) => {
              this.setState({
                voiceApiError: res.msg,
                voiceBtnDisabled: false,
              });
            },
            noAuth
          );
        };

        /**
         * 发送邮件验证码
         */
        sendEmailCode = () => {
          const {
            codeFrom,
            behavior,
            email,
            noAuth,
            token,
            verifyStore,
            currencyId,
          } = this.props;

          this.setState({
            emailApiError: '',
            emailBtnDisabled: true,
          });
          verifyStore.sendEmailCode(
            codeFrom || CodeFrom.security,
            codeFrom === CodeFrom.security
              ? {
                  behavior,
                  email: email || '',
                  token: token || '',
                }
              : { currencyId },
            () => {
              this.emailSendTimeDown();
              this.setState({
                emailApiError: '',
                sendToEmail: true,
                emailBtnDisabled: false,
              });
            },
            (res) => {
              this.setState({
                emailApiError: res.msg,
                emailBtnDisabled: false,
              });
            },
            noAuth
          );
        };

        /**
         * 验证码倒计时
         */
        smsSendTimeDown = () => {
          this.setState(
            {
              smsCodeTime: 60,
            },
            () => {
              const clock = setInterval(() => {
                if (!this || !this.mounted) {
                  clearInterval(clock);
                  return;
                }
                const { smsCodeTime } = this.state;

                if (smsCodeTime > 0) {
                  this.setState({
                    smsCodeTime: smsCodeTime - 1,
                  });
                } else {
                  clearInterval(clock);
                }
              }, 1000);
            }
          );
        };

        /**
         * 验证码倒计时
         */
        voiceSendTimeDown = () => {
          this.setState(
            {
              voiceCodeTime: 60,
            },
            () => {
              const clock = setInterval(() => {
                if (!this || !this.mounted) {
                  clearInterval(clock);
                  return;
                }
                const { voiceCodeTime } = this.state;

                if (voiceCodeTime > 0) {
                  this.setState({
                    voiceCodeTime: voiceCodeTime - 1,
                  });
                } else {
                  clearInterval(clock);
                }
              }, 1000);
            }
          );
        };

        /**
         * 邮件验证码倒计时
         */
        emailSendTimeDown = () => {
          this.setState(
            {
              emailCodeTime: 60,
            },
            () => {
              const clock = setInterval(() => {
                if (!this || !this.mounted) {
                  clearInterval(clock);
                  return;
                }
                const { emailCodeTime } = this.state;

                if (emailCodeTime > 0) {
                  this.setState({
                    emailCodeTime: emailCodeTime - 1,
                  });
                } else {
                  clearInterval(clock);
                }
              }, 1000);
            }
          );
        };

        // 获取焦点事件
        inputFocus = (e) => {
          this.setState({
            focusItem: e.target.getAttribute('rel'),
            blurItem: '',
          });
        };

        // 谷歌短信切换
        switchGoogleSms = () => {
          const { verifyStore } = this.props;
          verifyStore.switchGoogleSms();
          this.setState(
            {
              googleCode: '',
              googleCodeError: '',
              smsCode: '',
              smsCodeError: '',
            },
            () => {
              this.codeChange();
            }
          );
        };

        // 语音短信切换
        switchSmsVoice = () => {
          const { verifyStore } = this.props;
          verifyStore.switchSmsVoice();
          this.setState(
            {
              voiceCodeError: '',
              smsCode: '',
              smsCodeError: '',
            },
            () => {
              this.codeChange();
            }
          );
        };

        // 谷歌语音切换
        switchGoogleVoice = () => {
          const { verifyStore } = this.props;
          verifyStore.switchGoogleVoice();
          this.setState(
            {
              googleCode: '',
              googleCodeError: '',
              smsCode: '',
              voiceCodeError: '',
            },
            () => {
              this.codeChange();
            }
          );
        };

        cleanValue = () => {
          const { verifyStore } = this.props;
          const { smsCode, emailCode, googleCode } = this.state;
          const { sms, email, google } = verifyStore.valueClean;
          this.setState(
            {
              smsCode: sms ? '' : smsCode,
              emailCode: email ? '' : emailCode,
              googleCode: google ? '' : googleCode,
            },
            () => {
              if (sms || email || google) {
                this.codeChange();
                verifyStore.onValueCleaned();
              }
            }
          );
        };

        cleanError = () => {
          const { verifyStore } = this.props;
          const { sms, email, google, voice } = verifyStore.errorClean;
          const {
            smsCodeError,
            voiceCodeError,
            emailCodeError,
            googleCodeError,
            emailApiError,
            smsApiError,
            voiceApiError,
          } = this.state;
          this.setState(
            {
              smsCodeError: sms ? '' : smsCodeError,
              voiceCodeError: voice ? '' : voiceCodeError,
              emailCodeError: email ? '' : emailCodeError,
              googleCodeError: google ? '' : googleCodeError,

              emailApiError: email ? '' : emailApiError,
              smsApiError: sms ? '' : smsApiError,
              voiceApiError: voice ? '' : voiceApiError,
            },
            () => {
              if (sms || email || google || voice) {
                verifyStore.onErrorCleaned();
              }
            }
          );
        };

        render() {
          const {
            smsCode,
            emailCode,
            googleCode,
            sendToEmail,
            sendToSms,
            smsCodeTime,
            emailCodeTime,
            voiceCodeTime,
            focusItem,
            blurItem,
            smsCodeError,
            emailCodeError,
            googleCodeError,
            voiceCodeError,
            smsApiError,
            voiceApiError,
            emailApiError,
            smsBtnDisabled,
            voiceBtnDisabled,
            emailBtnDisabled,
          } = this.state;

          const {
            verifyStore,
            profileStore,
            smsLabelTitle,
            newStyle = false,
          } = this.props;
          const { canSwitchGoogleSms, canSwitchSmsVoice, email, phone } =
            verifyStore;

          const verifyType = this.props.verify || verifyStore.verifyType;

          const aimEmail = email || profileStore.profile.email;
          const aimPhone = phone || profileStore.profile.phone;

          const body = (
            <React.Fragment>
              {verifyType.email && (
                <div
                  className="form-item code-item"
                  data-error={
                    (focusItem !== 'email' || blurItem === 'email') &&
                    emailCodeError.length !== 0
                  }
                  data-api-error={emailApiError.length !== 0}
                >
                  <span className="input-title">
                    {this.translate('check.emailCodeTitle')}
                  </span>
                  <div className="form-input-box">
                    <input
                      type="tel"
                      maxLength={CODE_LENGTH}
                      placeholder={this.translate('codeBox.inputEmailCode')}
                      className="input form-input sms-input"
                      value={emailCode}
                      onChange={this.emailCodeChange}
                      rel="email"
                      onBlur={this.inputBlur}
                      onFocus={this.inputFocus}
                    />
                    <button
                      className="send-button"
                      disabled={emailCodeTime > 0 || emailBtnDisabled}
                      onClick={this.sendEmailCode}
                    >
                      {emailCodeTime > 0
                        ? `${emailCodeTime}s`
                        : this.translate('user.operation.sendSms')}
                    </button>
                    <span className="form-error-tips">
                      {emailApiError || emailCodeError}
                    </span>
                    {sendToEmail && (
                      <div className="send-to">
                        {this.translate('codeBox.sendTo')}{' '}
                        <span className="account">{aimEmail}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {verifyType.sms && (
                <div
                  className="form-item code-item"
                  data-error={
                    (focusItem !== 'sms' || blurItem === 'sms') &&
                    smsCodeError.length !== 0
                  }
                  data-api-error={smsApiError.length !== 0}
                >
                  <span className="input-title">
                    {smsLabelTitle || this.translate('check.smsCodeTitle')}
                  </span>
                  <div className="form-input-box">
                    <input
                      type="tel"
                      maxLength={CODE_LENGTH}
                      placeholder={this.translate('codeBox.inputSmsCode')}
                      className="input form-input sms-input"
                      value={smsCode}
                      onChange={this.smsCodeChange}
                      rel="sms"
                      onBlur={this.inputBlur}
                      onFocus={this.inputFocus}
                    />
                    <button
                      className="send-button"
                      disabled={smsCodeTime > 0 || smsBtnDisabled}
                      onClick={this.sendSmsCode}
                    >
                      {smsCodeTime > 0
                        ? `${smsCodeTime}s`
                        : this.translate('user.operation.sendSms')}
                    </button>
                    <div className="error-verify-box">
                      <span className="form-error-tips">
                        {smsApiError || smsCodeError}
                      </span>
                    </div>
                    {sendToSms && (
                      <div className="send-to">
                        {this.translate('codeBox.sendTo')}{' '}
                        <span className="account">{aimPhone}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {verifyType.voice && (
                <div
                  className="form-item code-item"
                  data-error={
                    (focusItem !== 'voice' || blurItem === 'voice') &&
                    voiceCodeError.length !== 0
                  }
                  data-api-error={voiceApiError.length !== 0}
                >
                  <span className="input-title">
                    {this.translate('check.voiceCodeTitle')}
                  </span>
                  <div className="form-input-box">
                    <input
                      type="tel"
                      maxLength={CODE_LENGTH}
                      placeholder={this.translate('codeBox.inputVoiceCode')}
                      className="input form-input sms-input"
                      value={smsCode}
                      onChange={this.voiceCodeChange}
                      rel="voice"
                      onBlur={this.inputBlur}
                      onFocus={this.inputFocus}
                    />
                    <button
                      className="send-button"
                      disabled={voiceCodeTime > 0 || voiceBtnDisabled}
                      onClick={this.sendVoiceCode}
                    >
                      {voiceCodeTime > 0
                        ? `${voiceCodeTime}s`
                        : this.translate('user.operation.sendSms')}
                    </button>
                    <div className="error-verify-box">
                      <span className="form-error-tips">
                        {voiceApiError || voiceCodeError}
                      </span>
                      {(canSwitchSmsVoice || canSwitchGoogleSms) && (
                        <div className="tab-verify-code">
                          {this.translate('codeBox.switch')}
                          {
                            // 切换到谷歌
                            canSwitchGoogleSms && (
                              <span
                                className="switch-type"
                                onClick={this.switchGoogleVoice}
                              >
                                {this.translate('codeBox.toGoogle')}
                              </span>
                            )
                          }
                          {canSwitchSmsVoice && canSwitchGoogleSms && (
                            <span>{this.translate('codeBox.or')}</span>
                          )}
                          {
                            // 切换到短信
                            canSwitchSmsVoice && (
                              <span
                                className="switch-type"
                                onClick={this.switchSmsVoice}
                              >
                                {this.translate('codeBox.toSms')}
                              </span>
                            )
                          }
                        </div>
                      )}
                    </div>
                    {sendToSms && (
                      <div className="send-to">
                        {this.translate('codeBox.sendTo')}{' '}
                        <span className="account">{aimPhone}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {verifyType.google && (
                <div
                  className="form-item code-item"
                  data-error={
                    (focusItem !== 'google' || blurItem === 'google') &&
                    googleCodeError.length !== 0
                  }
                >
                  <span className="input-title">
                    {this.translate('check.googleCodeTitle')}
                  </span>
                  <div className="form-input-box">
                    <input
                      type="tel"
                      maxLength={CODE_LENGTH}
                      placeholder={this.translate('codeBox.inputGoogleCode')}
                      className="input form-input"
                      value={googleCode}
                      onChange={this.googleCodeChange}
                      rel="google"
                      onBlur={this.inputBlur}
                      onFocus={this.inputFocus}
                    />
                    <span className="form-error-tips">{googleCodeError}</span>
                    {
                      // 切换到短信
                      canSwitchGoogleSms && (
                        <div className="switch-verify-box">
                          <div className="tab-verify-code">
                            {this.translate('codeBox.switch')}
                            <span
                              className="switch-type"
                              onClick={this.switchGoogleSms}
                            >
                              {this.translate('codeBox.toSms')}
                            </span>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              )}
            </React.Fragment>
          );

          const newBody = (
            <React.Fragment>
              {verifyType.email && (
                <div className="form-item from-item-new code-item">
                  <Input
                    size={Input.SIZE.xl}
                    className="form-input"
                    title={this.translate('check.emailCodeTitle')}
                    error={emailApiError || emailCodeError}
                    maxLength={CODE_LENGTH}
                    placeholder={this.translate('codeBox.inputEmailCode')}
                    value={emailCode}
                    onChange={this.emailCodeChange}
                    rel="email"
                    onBlur={this.inputBlur}
                    tips={
                      sendToEmail && (
                        <div className="send-to">
                          {this.translate('codeBox.sendTo')}{' '}
                          <span className="account">{aimEmail}</span>
                        </div>
                      )
                    }
                  />
                  <Button
                    size={Button.SIZE.lg}
                    category={Button.CATEGORY.outline}
                    className="form-button"
                    type={Button.TYPE.highlight}
                    disabled={emailCodeTime > 0 || emailBtnDisabled}
                    onClick={this.sendEmailCode}
                  >
                    {emailCodeTime > 0
                      ? `${emailCodeTime}s`
                      : this.translate('user.operation.sendSms')}
                  </Button>
                </div>
              )}

              {verifyType.sms && (
                <div className="form-item from-item-new code-item">
                  <Input
                    size={Input.SIZE.xl}
                    className="form-input"
                    title={
                      smsLabelTitle || this.translate('check.smsCodeTitle')
                    }
                    error={smsApiError || smsCodeError}
                    type="tel"
                    maxLength={CODE_LENGTH}
                    placeholder={this.translate('codeBox.inputSmsCode')}
                    value={smsCode}
                    onChange={this.smsCodeChange}
                    rel="sms"
                    onBlur={this.inputBlur}
                    tips={
                      sendToSms && (
                        <div className="send-to">
                          {this.translate('codeBox.sendTo')}{' '}
                          <span className="account">{aimPhone}</span>
                        </div>
                      )
                    }
                  />
                  <Button
                    size={Button.SIZE.lg}
                    category={Button.CATEGORY.outline}
                    className="form-button"
                    type={Button.TYPE.highlight}
                    disabled={smsCodeTime > 0 || smsBtnDisabled}
                    onClick={this.sendSmsCode}
                  >
                    {smsCodeTime > 0
                      ? `${smsCodeTime}s`
                      : this.translate('user.operation.sendSms')}
                  </Button>
                </div>
              )}

              {verifyType.google && (
                <div className="form-item from-item-new code-item">
                  <Input
                    size={Input.SIZE.xl}
                    className="form-input"
                    title={this.translate('check.googleCodeTitle')}
                    error={googleCodeError}
                    type="tel"
                    maxLength={CODE_LENGTH}
                    placeholder={this.translate('codeBox.inputGoogleCode')}
                    value={googleCode}
                    onChange={this.googleCodeChange}
                    rel="google"
                    onBlur={this.inputBlur}
                    tips={
                      canSwitchGoogleSms && (
                        <div className="switch-verify-box">
                          <div className="tab-verify-code">
                            {this.translate('codeBox.switch')}
                            <span
                              className="switch-type"
                              onClick={this.switchGoogleSms}
                            >
                              {this.translate('codeBox.toSms')}
                            </span>
                          </div>
                        </div>
                      )
                    }
                  />
                </div>
              )}
            </React.Fragment>
          );

          return newStyle ? newBody : body;
        }
      }
    )
  )
);

export { CodeBox, CodeFrom };
